import script from "./IndexViewNews.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexViewNews.vue?vue&type=script&setup=true&lang=js"

import "./IndexViewNews.vue?vue&type=style&index=0&id=d9ce4d6c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9ce4d6c"]])

export default __exports__